import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCupcake = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	"data-name": "Layer 1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-6 -6 36 36",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			className: "plan2plate-icon",
			d: "M18.82,13.05a3.63,3.63,0,0,1-2.62-1.12,3.26,3.26,0,0,1-.34-.4,4.18,4.18,0,0,1-7.72,0,3.26,3.26,0,0,1-.34.4,3.63,3.63,0,0,1-2.62,1.12,3.47,3.47,0,0,1-1.34-.25L5.7,22.5H18.3l1.86-9.7A3.47,3.47,0,0,1,18.82,13.05Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "plan2plate-icon",
			d: "M22.49,9.23a.71.71,0,0,1,0,.15,3.54,3.54,0,0,1-.78,2.23,3.59,3.59,0,0,1-2.9,1.44,3.63,3.63,0,0,1-2.62-1.12,3.26,3.26,0,0,1-.34-.4,4.18,4.18,0,0,1-7.72,0,3.26,3.26,0,0,1-.34.4,3.63,3.63,0,0,1-2.62,1.12,3.47,3.47,0,0,1-1.34-.25,3.47,3.47,0,0,1-1.56-1.19A3.54,3.54,0,0,1,1.5,9.38a.71.71,0,0,1,0-.15v0c0-.12,0-.23,0-.35C1.5,4.79,6.2,1.5,12,1.5S22.5,4.79,22.5,8.85c0,.12,0,.23,0,.35Z"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 12,
			y1: 5.32,
			x2: 12,
			y2: 9.14
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 8.18,
			y1: 5.32,
			x2: 6.27,
			y2: 8.18
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 15.82,
			y1: 5.32,
			x2: 17.73,
			y2: 8.18
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 9.9,
			y1: 22.5,
			x2: 9.02,
			y2: 12.85
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 14.98,
			y1: 12.85,
			x2: 14.1,
			y2: 22.5
		})
	]
});
const ForwardRef = forwardRef(SvgCupcake);
export default ForwardRef;
